if (!customElements.get('gm-product-tabs')) {
  customElements.define('gm-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const overview = this.querySelector('.gm-product-tabs__source');
      if (!overview) return;
      this.ready = true;
      const headings = [...overview.querySelectorAll('h2,h3,h4')];
      const normalize = node => node.textContent.replace(/\s/g, '');
      headings.forEach(heading => {
        if (normalize(heading) !== '主な特徴') return;
        const list = heading.nextElementSibling;
        if (list?.matches('ul') && list.textContent.includes('耐摩耗性') && list.textContent.includes('ゴム臭')) {
          list.remove(); heading.remove();
        }
      });
      const specs = document.createElement('div');
      specs.className = 'rte product-description';
      const heading = headings.find(node => /^(製品仕様|仕様|スペック|Specifications)$/i.test(normalize(node)));
      const table = heading?.nextElementSibling;
      if (table?.matches('table')) {
        specs.append(table); heading.remove();
      }
      const panels = [overview];
      const labels = [this.dataset.overview];
      if (specs.hasChildNodes()) { panels.push(specs); labels.push(this.dataset.specs); }
      const list = document.createElement('div');
      list.className = 'gm-product-tabs__nav';
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', this.dataset.overview);
      const buttons = panels.map((panel, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = labels[index];
        button.id = `gm-tab-${this.dataset.tabId}-${index}`;
        panel.id = `gm-panel-${this.dataset.tabId}-${index}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;
        list.append(button); this.append(panel);
        return button;
      });
      this.prepend(list);
      const activate = (index, focus = false) => {
        buttons.forEach((button, i) => {
          button.setAttribute('aria-selected', String(i === index));
          button.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) buttons[index].focus();
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      activate(0);
    }
  });
}
